( function( $ ) {
  /* Make the title height adjustable */
  if( $( this ).width() >= 624 ) {
    var heights = $( '.__blog' ).map( function( i, el ) {
      return $( 'h3', el ).height();
    } ).get();
  
    $( '.__blog h3' ).height( Math.max.apply( Math, heights ) );
  } else {
    $( '.__blog h3' ).height( 'auto' );
  }

  $( window ).resize( function () {
    if( $( this ).width() >= 624 ) {
      heights = $( '.__blog' ).map( function( i, el ) {
        return $( 'h3', el ).height();
      } ).get();
    
      $( '.__blog h3' ).height( Math.max.apply( Math, heights ) );
    } else {
      $( '.__blog h3' ).height( 'auto' );
    }
  } );

  /**
   * On change of the action
   */
  $( 'select[name="sort_by"]' ).on( 'change', function() {
    document.forms['blog-action'].submit();
  } );

  $( 'select[name="show"]' ).on( 'change', function() {
    document.forms['blog-action'].submit();
  } );
} ) ( jQuery );